<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">
          {{ $t('recipients.details.list.bank.title') }}
          <span style="font-weight: 400">{{ data.id }}</span>
        </h2>
        <div style="display: flex">
          <h2
            class="emd-text _size_section"
            style="margin-right: 5px"
          >
            {{ $t('recipients.details.list.bank.status_list') }}
          </h2>
          <span
            class="emd-badge"
            v-bind:class="status"
          >
            {{ data.status_label }}
          </span>
        </div>
      </div>
      <div class="emd-table-responsive">
        <Table
          :fields="fields"
          :items="[data]"
        ></Table>
      </div>
    </div>
  </div>
</template>
<script>
import Table from '@/components/project/molecules/Table.vue'
import { statusClass } from '@/filters'
import {
  recipientType,
  recipientStatus,
  backAccountType
} from '@/filters/recipients'

export class BankDetail {
  constructor (
    id,
    status,
    holder,
    holderType,
    holderDocument,
    bank,
    agency,
    dv,
    account,
    accountDV,
    type,
    createdAt,
    updatedAt
  ) {
    this.id = id
    this.status = recipientStatus(status)
    this.status_label = status
    this.holder_name = holder
    this.holder_type = recipientType(holderType)
    this.holder_document = holderDocument
    this.bank = bank
    this.branch_number = agency
    this.branch_check_digit = dv
    this.account_number = account
    this.account_check_digit = accountDV
    this.type = type && backAccountType(type)
    this.type_label = type
    this.createdAt = createdAt
    this.updatedAt = updatedAt
  }
}

export default {
  name: 'RecipientBankDetail',
  components: {
    Table
  },
  props: {
    data: new BankDetail()
  },
  data () {
    return {
      fields: [
        {
          id: 'holder_name',
          label: 'recipients.details.list.bank.holder',
          type: 'text'
        },
        {
          id: 'bank',
          label: 'recipients.details.list.bank.bank',
          type: 'text'
        },
        {
          id: 'branch_number',
          label: 'recipients.details.list.bank.agency',
          type: 'text'
        },
        {
          id: 'branch_check_digit',
          label: 'recipients.details.list.bank.dv',
          type: 'text'
        },
        {
          id: 'account_number',
          label: 'recipients.details.list.bank.account',
          type: 'text'
        },
        {
          id: 'account_check_digit',
          label: 'recipients.details.list.bank.account_dv',
          type: 'text'
        },
        {
          id: 'type_label',
          label: 'recipients.details.list.bank.type',
          type: 'text'
        },
        {
          id: 'createdAt',
          label: 'recipients.details.list.bank.created_at',
          type: 'date',
          format: 'date'
        },
        {
          id: 'updatedAt',
          label: 'recipients.details.list.bank.updated_at',
          type: 'date',
          format: 'date'
        }
      ]
    }
  },
  computed: {
    status () {
      return statusClass(this.data.status_label)
    }
  }
}
</script>
